/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Validation } from './validation';


export interface FieldConfig { 
    collection?: any;
    group?: string;
    label?: string;
    labels?: { [key: string]: string; };
    name?: string;
    options?: Array<string>;
    placeholder?: string;
    type?: FieldConfig.TypeEnum;
    typeOption?: FieldConfig.TypeOptionEnum;
    validations?: Array<Validation>;
    value?: any;
}
export namespace FieldConfig {
    export type TypeEnum = 'INPUT' | 'RADIOBUTTON' | 'DATE' | 'SELECT' | 'SELECT_AIRPORT' | 'CHECKBOX' | 'CAPTCHA' | 'BUTTON' | 'LABEL';
    export const TypeEnum = {
        INPUT: 'INPUT' as TypeEnum,
        RADIOBUTTON: 'RADIOBUTTON' as TypeEnum,
        DATE: 'DATE' as TypeEnum,
        SELECT: 'SELECT' as TypeEnum,
        SELECTAIRPORT: 'SELECT_AIRPORT' as TypeEnum,
        CHECKBOX: 'CHECKBOX' as TypeEnum,
        CAPTCHA: 'CAPTCHA' as TypeEnum,
        BUTTON: 'BUTTON' as TypeEnum,
        LABEL: 'LABEL' as TypeEnum
    };
    export type TypeOptionEnum = 'TEXT' | 'EMAIL' | 'PASSWORD';
    export const TypeOptionEnum = {
        TEXT: 'TEXT' as TypeOptionEnum,
        EMAIL: 'EMAIL' as TypeOptionEnum,
        PASSWORD: 'PASSWORD' as TypeOptionEnum
    };
}
